<al-description-modal></al-description-modal>

<ng-container *ngIf="LinkSettings$ | async as groupedLinkSettings">
	<div *ngIf="showInvoicePdfDeliveryManagement" class="pdf-delivery-tools">
		<div>
			<strong>Invoice PDF delivery</strong>
			<span>Review outstanding transfers or manually retry and cancel deliveries.</span>
		</div>
		<button type="button" class="btn btn-sm btn-outline-primary" (click)="openInvoicePdfDeliveries()">
			<i class="far fa-file-pdf"></i>
			Manage deliveries
		</button>
	</div>

	<dx-accordion [collapsible]="true">
		<dxi-item title="General">
			<div class="card-body">
				<div *ngIf="formGroupCollection">
					<al-link-edit-general [formGroup]="formGroupCollection.get('general')" [link]="link"></al-link-edit-general>
				</div>
			</div>
		</dxi-item>
		<dxi-item title="Application logins">
			<div class="card-body">
				<al-link-edit-login-details [link]="link" [fromAppName]="linkInfo.fromDName" [toAppName]="linkInfo.toDName" [linkInfo]="linkInfo">
				</al-link-edit-login-details>
			</div>
		</dxi-item>
		<ng-container *ngFor="let sectionSettings of groupedLinkSettings | settingSectionSortPipe">
			<dxi-item title="{{ toCaption(sectionSettings.section) }}">
				<div class="card-body">

					<!-- Admin tools bar (integrated, compact) -->
					<ng-container *ngIf="canManageApplicationLinkAdministrationSubject | async">
						<div class="admin-tools-bar">
							<span class="admin-tools-label">Admin</span>

							<button type="button" class="admin-tool-btn" (click)="openAdminSettingManagementMenu()" title="Settings management" aria-label="Settings management">
          <i class="far fa-sliders-h"></i>
          <span>Setting configuration</span>
        </button>

							<button type="button" class="admin-tool-btn admin-tool-btn--freshdesk" (click)="openAdminSettingFreshdeskManagementMenu()" title="Freshdesk settings management" aria-label="Freshdesk settings management">
          <i class="far fa-life-ring"></i>
          <span>Freshdesk Article linking</span>
        </button>
						</div>
					</ng-container>

					<!-- Your existing content stays unchanged -->
					<ng-container *ngIf="sectionSettings.defaultAccess as accessGroup">
						<ng-container *ngIf="linkSettingGroupings | async as groupings">
							<fieldset *ngFor="let group of accessGroup.groups | settingGroupNameSortPipe: groupings">
								<legend>{{ group.name ? group.name : "Unassigned" }}</legend>
								<ng-container *ngIf="accessGroup.formGroup">
									<div>
										<al-link-edit-settings [link]="link" [dateFormat]="dateFormat" [setting]="setting" [form]="accessGroup.formGroup" [descriptionModal]="descriptionModal" *ngFor="let setting of group.settings | settingSortPipe">
										</al-link-edit-settings>
									</div>
								</ng-container>
							</fieldset>
						</ng-container>
					</ng-container>

				</div>

				<!-- nested dx-accordion stays as-is -->
				<dx-accordion noDataText="">
					<dxi-item *ngFor="let accessGroup of sectionSettings.accessGroups">
						<ng-container *ngIf="linkSettingGroupings | async as groupings">
							<fieldset *ngFor="let group of accessGroup.groups | settingGroupNameSortPipe: groupings">
								<legend>{{ group.name ? group.name : "General" }}</legend>
								<div class="settings-grid">
									<div class="card-body">
										<al-link-edit-settings [link]="link" [dateFormat]="dateFormat" [setting]="setting" [form]="accessGroup.formGroup" [descriptionModal]="descriptionModal" *ngFor="let setting of group.settings | settingSortPipe">
										</al-link-edit-settings>
									</div>
								</div>
							</fieldset>
						</ng-container>
					</dxi-item>
				</dx-accordion>
			</dxi-item>

		</ng-container>
		<!-- *ngIf="!this.linkInfo.frontendPage" -->
		<dxi-item title="Log">
			<div class="card-body">
				<al-link-log-settings [formGroup]="formGroupCollection.get('log')" [link]="link"></al-link-log-settings>
			</div>
		</dxi-item>
	</dx-accordion>
</ng-container>

<app-shell-link-edit-setting-grouping-admin></app-shell-link-edit-setting-grouping-admin>
<app-link-edit-settingtemplate-article-admin></app-link-edit-settingtemplate-article-admin>

<al-freshdesk-help-modal></al-freshdesk-help-modal>
<al-link-invoice-pdf-deliveries [linkId]="link.id ?? 0" (pendingCountChange)="updatePendingInvoicePdfDeliveryCount($event)"></al-link-invoice-pdf-deliveries>
